const bindings = [
  { name: 'account', isList: false },
  { name: 'accountStatus', isList: false },
  { name: 'accountTemplates', isList: true },
  { name: 'accountUsers', isList: true },
  { name: 'activeAccountTemplates', isList: true },
  { name: 'appUser', isList: false },
  { name: 'assets', isList: true },
  { name: 'associatedFirstParties', isList: true },
  { name: 'clientUsers', isList: true },
  { name: 'counterpartyUsers', isList: true },
  { name: 'globalFeatureToggleSet', isList: false },
  { name: 'userFeatureToggleSet', isList: false },
  { name: 'documents', isList: true },
  { name: 'inactiveClientUsers', isList: true },
  { name: 'pendingClientUsers', isList: true },
  { name: 'pinnedTemplates', isList: true },
  { name: 'receivedClientInvitations', isList: true },
  { name: 'selectedAccount', isList: false },
  { name: 'sentClientInvitations', isList: true },
  { name: 'shares', isList: true },
  { name: 'signatories', isList: true },
  { name: 'availableSubscriptionPlans', isList: true },
  { name: 'activePrices', isList: true },
  { name: 'userTemplateCategories', isList: true },
  { name: 'userTemplates', isList: true },
  { name: 'vaultDocuments', isList: true },
  { name: 'company', isList: false }
]

var bounds = {}
var binds = {}
var loadings = {}

bindings.forEach(({ name, isList }) => {
  binds[name + 'Binding'] = null
  loadings[name + 'Loading'] = true
  bounds[name] = isList ? [] : {}
})

const bindingsObj = { ...bounds, ...binds }

export { bounds, binds, loadings, bindingsObj }
